import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// components/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
var isAuthenticated = function () {
    return localStorage.getItem('token') !== null;
};
var PrivateRoute = function (_a) {
    var children = _a.children;
    return isAuthenticated() ? _jsx(_Fragment, { children: children }) : _jsx(Navigate, { to: '/', replace: true });
};
export default PrivateRoute;
